import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Button,
  Toolbar,
  CircularProgress,
} from "@mui/material";
import { _get } from "../../Config/axiosInstance";
import moment from "moment";

const Dashboard = () => {
  const [bookingData, setBookingData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [dashboardStats, setDashboardStats] = useState({
    totalTicketsThisMonth: 0,
    totalTicketsAvailable: 100, // Static or fetched separately
    trendingMovie: "Loading...",
    trendingOffer: "50% off on next booking!",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await _get("/bookinglist");
        const data = res.data.data || [];
        setBookingData(data);

        // Total tickets booked this month
        const thisMonth = moment().month();
        const totalTicketsThisMonth = data.reduce((sum, booking) => {
          const bookingMonth = moment(booking.movieDate).month();
          return bookingMonth === thisMonth ? sum + booking.movieTickets : sum;
        }, 0);

        // Determine trending movie
        const movieCount = {};
        data.forEach((item) => {
          movieCount[item.movieName] = (movieCount[item.movieName] || 0) + item.movieTickets;
        });

        //const trendingMovie = Object.entries(movieCount).sort((a, b) => b[1] - a[1])[0]?.[0] || "N/A";
        const sortedMovies = Object.entries(movieCount).sort((a, b) => b[1] - a[1]);
      const trendingMovie = sortedMovies[0]?.[0] || "N/A";

      const trendingOffer = trendingMovie !== "N/A"
      ? `🎉 Special offer: Buy 2 Get 1 Free on all ${trendingMovie} movies!`
      : "🎬 Stay tuned for upcoming offers!";


        setDashboardStats({
          totalTicketsThisMonth,
          totalTicketsAvailable: 100 - totalTicketsThisMonth,
          trendingMovie,
          trendingOffer: "🎉 Buy 2 Get 1 Free on all Marvel Movies!",
        });
      } catch (err) {
        console.error("Failed to fetch dashboard data", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <Box textAlign="center" mt={5}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", p: 3 }}>
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Toolbar />
        <Grid container spacing={3}>
          {/* Total Tickets This Month */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper elevation={4} sx={{ p: 3, borderRadius: 3, bgcolor: "#e3f2fd" }}>
              <Typography variant="h6" gutterBottom>
                🎟 Tickets This Month
              </Typography>
              <Typography variant="h4" color="primary">
                {dashboardStats.totalTicketsThisMonth}
              </Typography>
            </Paper>
          </Grid>

        {/* Total Bookings (response length) */}
<Grid item xs={12} sm={6} md={3}>
  <Paper elevation={4} sx={{ p: 3, borderRadius: 3, bgcolor: "#ede7f6" }}>
    <Typography variant="h6" gutterBottom>
      📊 Total Bookings
    </Typography>
    <Typography variant="h4" color="info.main">
      {bookingData.length}
    </Typography>
  </Paper>
</Grid>



          {/* Trending Movie */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper elevation={4} sx={{ p: 3, borderRadius: 3, bgcolor: "#e8f5e9" }}>
              <Typography variant="h6" gutterBottom>
                🔥 Trending Movie
              </Typography>
              <Typography variant="h5" color="success.main">
                {dashboardStats.trendingMovie}
              </Typography>
            </Paper>
          </Grid>

          {/* Trending Offer */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper elevation={4} sx={{ p: 3, borderRadius: 3, bgcolor: "#fff3e0" }}>
              <Typography variant="h6" gutterBottom>
                🏷 Trending Offer
              </Typography>
              <Typography variant="body1">{dashboardStats.trendingOffer}</Typography>
            </Paper>
          </Grid>

          {/* Highlight Box */}
          <Grid item xs={12}>
            <Paper elevation={6} sx={{ p: 4, borderRadius: 3, mt: 2 }}>
              <Typography variant="h6" gutterBottom>
                ⭐ Featured Movie Offer
              </Typography>
              <Typography>
                Enjoy <strong>50% off</strong> on the latest blockbuster: <strong>"The Time Traveler"</strong>.
                <br />
                Offer valid until <strong>{moment().endOf("month").format("MMMM Do")}</strong>.
              </Typography>
              <Button variant="contained" color="primary" sx={{ mt: 2 }}>
                View Offer
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Dashboard;
